import { createDiscountRequest, fetchDiscountRequest, updateDiscountRequest, fetchDiscountsRequest, deleteDiscountRequest } from '../api/index'
import { handleErrorRequest } from '../helpers/api'
import _ from 'lodash'
import { createActions, handleActions } from 'redux-actions'

const identity = name => payload => ({ [name]: payload })
const failIdentity = identity('failMessage')

const createdActions = createActions({
  discounts: {
    SUBMIT_DISCOUNT_ATTEMPT: null,
    SUBMIT_DISCOUNT_FAILURE: failIdentity,
    SUBMIT_DISCOUNT_SUCCESS: null,
    DELETE_DISCOUNT_ATTEMPT: null,
    DELETE_DISCOUNT_FAILURE: failIdentity,
    DELETE_DISCOUNT_SUCCESS: null,
    FETCH_DISCOUNT_ATTEMPT: null,
    FETCH_DISCOUNT_FAILURE: failIdentity,
    FETCH_DISCOUNT_SUCCESS: null,
    FETCH_DISCOUNTS_ATTEMPT: null,
    FETCH_DISCOUNTS_FAILURE: failIdentity,
    FETCH_DISCOUNTS_SUCCESS: null,
    SET_CURRENT_DISCOUNT: identity('currentDiscount'),
    SET_DISCOUNTS: identity('discounts'),
    RESET_STATE: null
  }
})

const {
  discounts: {
    submitDiscountAttempt,
    submitDiscountFailure,
    submitDiscountSuccess,
    deleteDiscountAttempt,
    deleteDiscountFailure,
    deleteDiscountSuccess,
    fetchDiscountAttempt,
    fetchDiscountFailure,
    fetchDiscountSuccess,
    fetchDiscountsAttempt,
    fetchDiscountsFailure,
    fetchDiscountsSuccess,
    setDiscounts,
    setCurrentDiscount,
  }
} = createdActions

const createDiscountAsync = ({ dealer_id, contract_id, data }) => (dispatch, getState) => {
  dispatch(submitDiscountAttempt())
  let jwt = _.get(getState(), 'auth.user.jwt', '')
  return createDiscountRequest({ data: { discount: data }, dealer_id, contract_id, jwt }).then(({ response, error }) => {
    if (response) {
      dispatch(submitDiscountSuccess())
      dispatch(createDiscountSync(response.data.id, response.data))
      return Promise.resolve(response.data)
    } else {
      dispatch(submitDiscountFailure(handleErrorRequest(error)))
      return Promise.reject(error)
    }
  })
}

const createDiscountSync = (id, discount) => (dispatch, getState) => {
  const discounts = getState().discounts.discounts || []
  const discountCopy = Object.assign({}, { id }, discount)
  dispatch(setDiscounts([...discounts, discountCopy]))
}

const fetchDiscount = ({ dealer_id, contract_id, discount_id }) => (dispatch, getState) => {
  dispatch(fetchDiscountAttempt())
  let jwt = _.get(getState(), 'auth.user.jwt', '')
  return fetchDiscountRequest({ discount_id, dealer_id, contract_id, jwt }).then(({ response, error }) => {
    if (response) {
      dispatch(fetchDiscountSuccess())
      dispatch(setCurrentDiscount(response.data))
      return Promise.resolve(response.data)
    } else {
      dispatch(fetchDiscountFailure(handleErrorRequest(error)))
      return Promise.reject(error)
    }
  })
}

const fetchDiscounts = ({ dealer_id, contract_id }) => (dispatch, getState) => {
  dispatch(fetchDiscountsAttempt())
  let jwt = _.get(getState(), 'auth.user.jwt', '')
  return fetchDiscountsRequest({ dealer_id, contract_id, jwt }).then(({ response, error }) => {
    if (response) {
      dispatch(fetchDiscountsSuccess())
      dispatch(setDiscounts(response.data))
      return Promise.resolve(response.data)
    } else {
      dispatch(fetchDiscountsFailure(handleErrorRequest(error)))
      return Promise.reject(error)
    }
  })
}

const updateDiscountAsync = ({ dealer_id, contract_id, discount_id, data }) => (dispatch, getState) => {
  dispatch(submitDiscountAttempt())
  let jwt = _.get(getState(), 'auth.user.jwt', '')
  return updateDiscountRequest({ dealer_id, discount_id, contract_id, data: { discount: data }, jwt }).then(({ response, error }) => {
    if (response) {
      dispatch(submitDiscountSuccess())
      dispatch(setCurrentDiscount(null))
      dispatch(updateDiscountSync(response.data))
      return Promise.resolve(response.data)
    } else {
      dispatch(submitDiscountFailure(handleErrorRequest(error)))
      return Promise.reject(error)
    }
  })
}

const updateDiscountSync = (discount) => (dispatch, getState) => {
  const currentDiscount = getState().discounts.currentDiscount || { id: discount.id }
  const discounts = [...getState().discounts.discounts]
  var index = _.findIndex(discounts, { id: currentDiscount.id })
  if (index !== -1) {
    discounts.splice(index, 1, Object.assign({}, currentDiscount, discount))
    dispatch(setDiscounts([...discounts]))
  }
  dispatch(setCurrentDiscount(null))
}

const deleteDiscountAsync = ({ dealer_id, contract_id, discount_id }) => (dispatch, getState) => {
  dispatch(deleteDiscountAttempt())
  let jwt = _.get(getState(), 'auth.user.jwt', '')
  return deleteDiscountRequest({ dealer_id, discount_id, contract_id, jwt }).then(({ response, error }) => {
    if (response) {
      dispatch(deleteDiscountSuccess())
      dispatch(deleteDiscountSync(discount_id))
    } else {
      dispatch(deleteDiscountFailure(handleErrorRequest(error)))
    }
  })
}

const deleteDiscountSync = (discount_id) => (dispatch, getState) => {
  const discounts = getState().discounts.discounts || []
  const currentDiscount = getState().discounts.currentDiscount || {}
  let nextDiscounts = _.reject(discounts, { id: discount_id })
  dispatch(setDiscounts(nextDiscounts))
  discount_id === currentDiscount.id && dispatch(setCurrentDiscount(null))
}

export const actions = { ...createdActions.discounts, createDiscountAsync, createDiscountSync, updateDiscountAsync, updateDiscountSync, deleteDiscountAsync, deleteDiscountSync, fetchDiscount, fetchDiscounts }

export const initialState = {
  submittingDiscount: false,
  failSubmitDiscount: null,
  successSubmitDiscount: false,
  fetchingDiscount: false,
  failFetchDiscount: null,
  successFetchDiscount: false,
  currentDiscount: null,
  fetchingDiscounts: false,
  failFetchDiscounts: null,
  successFetchDiscounts: false,
  discounts: []
}

const simplePayloadMutation = (state, { payload }) => ({ ...state, ...payload })

export default handleActions({
  discounts: {
    SUBMIT_DISCOUNT_ATTEMPT: (state, action) =>
      ({ ...state, submittingDiscount: true, failSubmitDiscount: null, successSubmitDiscount: false }),
    SUBMIT_DISCOUNT_SUCCESS: (state, action) =>
      ({ ...state, submittingDiscount: false, failSubmitDiscount: null, successSubmitDiscount: true }),
    SUBMIT_DISCOUNT_FAILURE: (state, { payload: { failMessage } }) =>
      ({ ...state, submittingDiscount: false, failSubmitDiscount: failMessage, successSubmitDiscount: false }),
    DELETE_DISCOUNT_ATTEMPT: (state, action) =>
      ({ ...state, submittingDiscount: true, failSubmitDiscount: null, successSubmitDiscount: false }),
    DELETE_DISCOUNT_SUCCESS: (state, action) =>
      ({ ...state, submittingDiscount: false, failSubmitDiscount: null, successSubmitDiscount: true }),
    DELETE_DISCOUNT_FAILURE: (state, { payload: { failMessage } }) =>
      ({ ...state, submittingDiscount: false, failSubmitDiscount: failMessage, successSubmitDiscount: false }),
    FETCH_DISCOUNT_ATTEMPT: (state, action) =>
      ({ ...state, fetchingDiscount: true, failFetchDiscount: null, successFetchDiscount: false }),
    FETCH_DISCOUNT_SUCCESS: (state, action) =>
      ({ ...state, fetchingDiscount: false, failFetchDiscount: null, successFetchDiscount: true }),
    FETCH_DISCOUNT_FAILURE: (state, { payload: { failMessage } }) =>
      ({ ...state, fetchingDiscount: false, failFetchDiscount: failMessage, successFetchDiscount: false }),
    FETCH_DISCOUNTS_ATTEMPT: (state, action) =>
      ({ ...state, fetchingDiscounts: true, failFetchDiscounts: null, successFetchDiscounts: false }),
    FETCH_DISCOUNTS_SUCCESS: (state, action) =>
      ({ ...state, fetchingDiscounts: false, failFetchDiscounts: null, successFetchDiscounts: true }),
    FETCH_DISCOUNTS_FAILURE: (state, { payload: { failMessage } }) =>
      ({ ...state, fetchingDiscounts: false, failFetchDiscounts: failMessage, successFetchDiscounts: false }),
    SET_CURRENT_DISCOUNT: simplePayloadMutation,
    SET_DISCOUNTS: simplePayloadMutation,
    RESET_STATE: (state, action) =>
      ({ ...state, ...initialState, ...{ discounts: state.discounts, currentDiscount: state.currentDiscount } })
  }
}, initialState)